export const DEFAULT_TTL_MS = 24 * 60 * 60 * 1000;
